/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SafetyDto } from '../../models/safety-dto';

export interface GetSafetiesForCustomer$Params {
  customerGUID: string;
}

export function getSafetiesForCustomer(http: HttpClient, rootUrl: string, params: GetSafetiesForCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SafetyDto>>> {
  const rb = new RequestBuilder(rootUrl, getSafetiesForCustomer.PATH, 'get');
  if (params) {
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SafetyDto>>;
    })
  );
}

getSafetiesForCustomer.PATH = '/safeties';
